import React from "react";
import {ReactComponent as Border} from "../assets/images/border-fade.svg";
import closeIcon from "../assets/images/close.svg";
import checkIcon from "../assets/images/checked.svg";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import i18n from "../i18n";
import moment from "jalali-moment";

interface IProps {
  index: number;
  data?: any;
}

const VaccineDoses: React.FC<IProps> = ({index, data}) => {
  const {t} = useTranslation();
  return (
    <div
      key={index}
      className={`vaccination-detail-card ${!_.isEmpty(data) ? "active" : ""}`}
    >
      <div className="u-d-flex dose-detail">
        <span className="vaccine-dose">{`${t("Dose")} ${t(
          `${data.vaccineNumber}`
        )}`}</span>
        <div className="u-d-flex items-center">
          <img
            src={`${_.isEmpty(data) ? closeIcon : checkIcon}`}
            alt={!_.isEmpty(data) ? t("Not Vaccinated") : t("Complete")}
            className="mr-2"
            style={{paddingBottom: '0.4rem'}}
          />
          <span className="vaccine-status whitespace-nowrap">
            {_.isEmpty(data) ? t("Not Vaccinated") : t("Complete")}
          </span>
        </div>
      </div>

      <Border/>

      <div className="u-d-flex vaccination-detail u-margin-top-small-1">
        <div className="u-d-flex justify-between vaccination-detail-row">
          <div className="vaccination-detail-keyValue">
            <span className="key mr-2">{t("Date")}:</span>
            <span className="value">
              {_.isEmpty(data) ? "-" : i18n.dir() === "rtl" ? moment(data.date, "YYYY/MM/DD")
                .locale("fa")
                .format("YYYY/MM/DD") : data.date}
            </span>
          </div>
          <div className="vaccination-detail-keyValue">
            <span className="key mr-2">{t("Country")}:</span>
            <span className="value">{_.isEmpty(data) ? "-" : data.country}</span>
          </div>
        </div>
        <div className="u-d-flex justify-between vaccination-detail-row">
          <div className="vaccination-detail-keyValue">
            <span className="key mr-2">{t("MAH")}:</span>
            <span className="value">{_.isEmpty(data) ? "-" : data.manufacturer}</span>
          </div>
          <div className="vaccination-detail-keyValue">
            <span className="key mr-2">{t("Brand")}:</span>
            <span className="value">{_.isEmpty(data) ? "-" : data.title}</span>
          </div>
        </div>

        <div className="u-d-flex justify-center text-lg u-margin-top-small-1 vaccination-detail-serial">
          <span>{t("LUT Number")}:</span>
          <span>{data.batchNumber}</span>
        </div>
      </div>
    </div>
  );
};

export default VaccineDoses;
